module.exports = __webpack_public_path__ + "media/img/features/front-page-large-abd3d9a84dd77962559151436c8a7e29.png";